import { useState, useEffect } from "react";
import Image from "../Image";
import Icon from "../Icon";
import "./index.css";

interface ModalProps {
  isOpen: boolean;
  images: string[];
  onClose: () => void;
}

const Modal = ({ isOpen, images, onClose }: ModalProps) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalActive, setModalActive] = useState(false);

  useEffect(() => {
    setModalActive(isOpen);
  }, [isOpen]);

  const handleNextImage = () => {
    if (currentImageIndex < images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleClose = () => {
    setCurrentImageIndex(0);
    setModalActive(false);
    onClose();
  };

  return (
    <div
      className={`modal-overlay ${modalActive ? "active" : ""}`}
      onClick={handleClose}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="modal-close" onClick={handleClose}>
          <Icon type="close" />
        </span>
        <div className="modal-image-container">
          {images.map((image, index) => (
            <div
              className={`modal-image ${
                index === currentImageIndex ? "active" : ""
              }`}
            >
              {index === currentImageIndex && (
                <Image imagePath={image} key={index} />
              )}
            </div>
          ))}
        </div>
        {images.length > 1 && (
          <>
            <div className="modal-dots">
              {images.map((_, index) => (
                <div onClick={() => setCurrentImageIndex(index)}>
                  <Icon
                    type="circle"
                    color={index === currentImageIndex ? "#007CC3" : "#D9D9D9"}
                  />
                </div>
              ))}
            </div>
            <div
              className={`modal-button left ${
                currentImageIndex === 0 ? "disabled" : ""
              }`}
              onClick={handlePrevImage}
            >
              <Icon
                type="arrow-left"
                color={currentImageIndex === 0 ? "#BDBDBD" : "black"}
              />
            </div>
            <div
              className={`modal-button right ${
                currentImageIndex === images.length - 1 ? "disabled" : ""
              }`}
              onClick={handleNextImage}
            >
              <Icon
                type="arrow-right"
                color={
                  currentImageIndex === images.length - 1 ? "#BDBDBD" : "black"
                }
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Modal;
